import { createEntityAdapter, } from '@ngrx/entity';
import { UserJobStateDto } from '../../services/api.services';
import { AppError, AppErrorData } from '../../shared/utils';

export interface Job extends UserJobStateDto {
};

export interface TrackedJobOptions {
  pullInterval: number;
  maxFailures: number;
};

export interface TrackedJobState {
  jobId: any;
  job: Job;
  completed: boolean;
  getStateFailed: boolean;
  getStateFailures: number;
  getStateError: AppErrorData;
};

export interface TrackedJob extends TrackedJobOptions, TrackedJobState {
};

export const TrackedJobEntities = createEntityAdapter<TrackedJob>({
  selectId: t => t.jobId
});

